export const getResetCss = (_: string, iterator: number) => {
  return `
.${_}notification-${iterator} *:where(:not(html, iframe, canvas, img, svg, video, audio):not(svg *, symbol *)) {
    all: unset;
    display: revert;
}

.${_}notification-${iterator} *,
.${_}notification-${iterator} *::before,
.${_}notification-${iterator} *::after {
    box-sizing: border-box;
    border: none;
}

.${_}notification-${iterator} a,
.${_}notification-${iterator} button {
    cursor: revert;
}

.${_}notification-${iterator} ol,
.${_}notification-${iterator} ul,
.${_}notification-${iterator} menu {
    list-style: none;
}

.${_}notification-${iterator} img {
    max-inline-size: 100%;
    max-block-size: 100%;
}

.${_}notification-${iterator} table {
    border-collapse: collapse;
}

.${_}notification-${iterator} input,
.${_}notification-${iterator} textarea {
    -webkit-user-select: auto;
}

.${_}notification-${iterator} textarea {
    white-space: revert;
}

.${_}notification-${iterator} meter {
    -webkit-appearance: revert;
    appearance: revert;
}

.${_}notification-${iterator} :where(pre) {
    all: revert;
}

.${_}notification-${iterator} ::placeholder {
    color: unset;
}

.${_}notification-${iterator} ::marker {
    content: initial;
}

.${_}notification-${iterator} :where([hidden]) {
    display: none;
}

.${_}notification-${iterator} :where([contenteditable]:not([contenteditable="false"])) {
    -moz-user-modify: read-write;
    -webkit-user-modify: read-write;
    overflow-wrap: break-word;
    -webkit-line-break: after-white-space;
    -webkit-user-select: auto;
}

.${_}notification-${iterator} :where([draggable="true"]) {
    -webkit-user-drag: element;
}

.${_}notification-${iterator} :where(dialog:modal) {
    all: revert;
}
  `;
};
